const capitalizeWords = (value: string): string =>
  value
    .toLowerCase()
    .replace(/(^|[\s'-])\p{L}/gu, (letter) => letter.toUpperCase());

interface NameParts {
  readonly main: string;
  readonly parenthetical?: string;
}

const PARENTHETICAL_PATTERN =
  /^(?<main>.*?)\s*\((?<parenthetical>[^()]+)\)\s*$/;

const splitParenthetical = (value: string): NameParts => {
  const { main, parenthetical } =
    PARENTHETICAL_PATTERN.exec(value)?.groups ?? {};

  return main && parenthetical ? { main, parenthetical } : { main: value };
};

export const capitalizeName = (value: string): string => {
  const { main, parenthetical } = splitParenthetical(value);

  return parenthetical
    ? `${capitalizeWords(main)} (${capitalizeWords(parenthetical)})`
    : capitalizeWords(main);
};
